<h3 mat-dialog-title>Session Expired</h3>
<div mat-dialog-content>
    <p>Your session has expired. Please login again.</p>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close (click)="close()">OK</button>
</div>